import React from "react";
import styles from "./NavigationUserCard.module.scss";
import classNames from "classnames";

export interface NavigationUserCardProps {
  id: string;
  nombreSolicitante: string;
  estado?: "NUEVA" | "EN_VALIDACION" | "FINALIZADA" | "CANCELADA" | "RECHAZADO";
  fecha?: string;
}

const minWidth = 576;
const estadoF = "FINALIZADA";
const estadoN = "NUEVA";
const estadoE = "EN_VALIDACION";
const estadoR = "RECHAZADO";
const estadoC = "CANCELADA";

class NavigationUserCard extends React.PureComponent<NavigationUserCardProps, any> {

  LABEL_ESTADO_LARGE: string = "Estado de la radicación de los documentos: ";
  LABEL_ESTADO_SMALL: string = "Estado: ";
  LABEL_RECEPCION_LARGE: string = "Recepción de documentos: ";
  LABEL_RECEPCION_SMALL: string = "Recepción: ";

  constructor(props: any) {
    super(props);
    this.state = {
      width: window.innerWidth,
      labelEstado: this.LABEL_ESTADO_LARGE,
      labelRecepcion: "Recepción de documentos: "
    };
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentWillMount() {
    if (this.state.width <= minWidth) {
      this.setState({
        labelEstado: this.LABEL_ESTADO_SMALL,
        labelRecepcion: this.LABEL_RECEPCION_SMALL
      });
    }
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  updateDimensions() {
    this.setState({
      width: window.innerWidth
    });
    if (this.state.width <= minWidth) {
      this.setState({
        labelEstado: this.LABEL_ESTADO_SMALL,
        labelRecepcion: this.LABEL_RECEPCION_SMALL
      });
    } else {
      this.setState({
        labelEstado: this.LABEL_ESTADO_LARGE,
        labelRecepcion: this.LABEL_RECEPCION_LARGE
      });
    }
  }

  render() {

    let bulletStyle;
    if (this.props.estado === estadoR || this.props.estado === estadoC) {
      bulletStyle = {backgroundColor: "red"};
    } else if (this.props.estado === estadoE || this.props.estado === estadoN) {
      bulletStyle = {backgroundColor: "#00aecb"};
    } else if (this.props.estado === estadoF) {
      bulletStyle = {backgroundColor: "#97d700"};
    }

    let labelEstado;
    if (this.props.estado === "EN_VALIDACION") {
      labelEstado = "EN VALIDACIÓN";
    } else {
      labelEstado = this.props.estado;
    }

    return (
      <nav className={classNames("navbar fixed-top navbar-light", styles.UserBar)}>
        <div className={classNames("row", styles.FullWidth, styles.JustifyContent)}>
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
            <div id="nucNombreSolicitanteDiv" className={styles.Info}>
              <label className={styles.LabelMedium}>Nombre del solicitante:</label>
              <label className={styles.LabelBig}>{this.props.nombreSolicitante}</label>
            </div>
          </div>
          {this.props.estado &&
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
            <div id="nucEstadoDiv" className={styles.Info}>
              <label className={styles.LabelMedium}>{this.state.labelEstado}</label>
              <label className={styles.LabelBig}>
                <div id="nucBulletDiv" className={styles.Bullet} style={bulletStyle}/>
                {labelEstado}
              </label>
            </div>
          </div>
          }
          {this.props.fecha &&
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
            <div id="nucRecepcionDiv" className={styles.Info}>
              <label className={styles.LabelMedium}>{this.state.labelRecepcion}</label>
              <label className={styles.LabelBig}>{this.props.fecha}</label>
            </div>
          </div>
          }
        </div>
      </nav>
    );
  }

}

export default NavigationUserCard;
